import React from "react";
import { Badge } from "@mantine/core";

interface Props {
  totalItems: number;
  completedItems: number;
}

export const ReceivedCompletedAggregateIndicator: React.FC<Props> = ({
  totalItems,
  completedItems,
}) => {
  if (completedItems === 0) return null;

  return (
    <Badge color="violet" variant="outline">
      {completedItems} of {totalItems} items Received External
    </Badge>
  );
};
